// skipcq: JS-W1028
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

import PrimaryActionButton from '../common/PrimaryActionButton';
import PortfolioBeerLocationList from './PortfolioBeerLocationList';

function formatAbv(abv) {
  if (typeof abv !== 'number' || !Number.isFinite(abv)) {
    return '—';
  }
  return `${abv}% ABV`;
}

function BeerProfileDescription({ descriptionText }) {
  if (descriptionText) {
    return (
      <Typography variant="body1" color="text.secondary">
        {descriptionText}
      </Typography>
    );
  }

  return (
    <Typography variant="body2" color="text.secondary">
      No description yet.
    </Typography>
  );
}

BeerProfileDescription.propTypes = {
  descriptionText: PropTypes.string,
};

function BeerProfileMetadataCard({
  styleName,
  styleType,
  abv,
  descriptionText,
  listingLocationLabels = [],
  onEditOpen,
}) {
  return (
    <Card variant="outlined" sx={{ bgcolor: 'background.paper' }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography variant="body1" color="text.secondary" sx={{ fontStyle: 'italic' }}>
          {styleName}
        </Typography>
        {styleType.length > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {styleType}
          </Typography>
        )}
        <Typography variant="body1" sx={{ mt: 1.5, fontWeight: 600 }}>
          {formatAbv(abv)}
        </Typography>
        <PortfolioBeerLocationList locationLabels={listingLocationLabels} />
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            mt: 3,
            mb: 1,
          }}
        >
          Description
        </Typography>
        <BeerProfileDescription descriptionText={descriptionText} />
      </CardContent>
      <CardActions sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 3 } }}>
        <PrimaryActionButton onClick={onEditOpen}>
          Edit beer
        </PrimaryActionButton>
      </CardActions>
    </Card>
  );
}

BeerProfileMetadataCard.propTypes = {
  styleName: PropTypes.string.isRequired,
  styleType: PropTypes.string.isRequired,
  abv: PropTypes.number,
  descriptionText: PropTypes.string,
  listingLocationLabels: PropTypes.arrayOf(PropTypes.string),
  onEditOpen: PropTypes.func.isRequired,
};

function BeerProfileDetailsPanel({
  styleName,
  styleType,
  abv,
  descriptionText,
  listingLocationLabels = [],
  onEditOpen,
}) {
  return (
    <BeerProfileMetadataCard
      styleName={styleName}
      styleType={styleType}
      abv={abv}
      descriptionText={descriptionText}
      listingLocationLabels={listingLocationLabels}
      onEditOpen={onEditOpen}
    />
  );
}

BeerProfileDetailsPanel.propTypes = {
  styleName: PropTypes.string.isRequired,
  styleType: PropTypes.string.isRequired,
  abv: PropTypes.number,
  descriptionText: PropTypes.string,
  listingLocationLabels: PropTypes.arrayOf(PropTypes.string),
  onEditOpen: PropTypes.func.isRequired,
};

export { BeerProfileMetadataCard };
export default BeerProfileDetailsPanel;
